import { matchPath } from 'react-router-dom';
import type { RouteGroup } from '@usealloy/daffy-to-frontend-dashboard-rollout';

export function findMatchedGroupAndPath(args: {
  routeRegistry: RouteGroup[];
  daffyPathname: string;
}) {
  const { routeRegistry, daffyPathname } = args;

  for (const routeGroup of routeRegistry) {
    for (const path of routeGroup.paths) {
      const match = matchPath(path.daffy, daffyPathname);

      if (match) {
        return {
          matchedRouteGroup: routeGroup,
          matchedPath: path,
          params: match.params,
        };
      }
    }
  }

  return null;
}
